import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl32 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".white{fill:#fff;}.red{fill:#ec0016;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_32",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "STOP_Sign",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "red",
					d: "M48.56,8h-9.11c-.27,0-.52.11-.71.29l-6.44,6.44c-.19.19-.29.44-.29.71v9.11c0,.27.11.52.29.71l6.44,6.44c.19.19.44.29.71.29h9.11c.27,0,.52-.11.71-.29l6.44-6.44c.19-.19.29-.44.29-.71v-9.11c0-.27-.11-.52-.29-.71l-6.44-6.44c-.19-.19-.44-.29-.71-.29Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "white",
					d: "M39.63,18.42h-1.12v-.25c0-.26-.06-.48-.18-.67-.12-.19-.32-.28-.61-.28-.15,0-.28.03-.37.09-.1.06-.17.13-.23.22-.06.09-.1.2-.12.32-.02.12-.03.25-.03.38,0,.15,0,.28.02.38.01.1.04.19.08.28.04.08.11.15.19.21s.2.12.35.18l.86.34c.25.1.45.21.6.33.15.13.28.28.36.45.08.18.14.38.17.6s.04.48.04.76c0,.33-.03.64-.1.92-.07.28-.17.52-.32.72-.15.21-.36.37-.61.48s-.55.18-.91.18c-.27,0-.52-.05-.76-.14-.23-.09-.44-.23-.6-.4s-.3-.37-.4-.59c-.1-.22-.15-.47-.15-.73v-.42h1.12v.35c0,.21.06.39.18.56s.32.25.61.25c.19,0,.34-.03.45-.08.11-.05.19-.13.25-.24s.09-.23.1-.37c.01-.14.02-.3.02-.48,0-.21,0-.37-.02-.51-.01-.13-.04-.24-.09-.32-.05-.08-.12-.15-.2-.2-.08-.05-.2-.11-.34-.17l-.8-.33c-.48-.2-.81-.46-.97-.79s-.25-.74-.25-1.23c0-.29.04-.57.12-.84.08-.26.2-.49.36-.68.15-.19.35-.34.59-.46.24-.11.52-.17.85-.17.28,0,.53.05.76.15.23.1.43.24.6.41.34.35.51.75.51,1.21v.55Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "white",
					d: "M41.17,23.99v-6.78h-1.3v-1.06h3.72v1.06h-1.3v6.78h-1.12Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "white",
					d: "M43.86,18.01c0-.31.05-.59.17-.84.11-.24.26-.44.44-.6.18-.15.38-.27.6-.35.22-.08.45-.12.68-.12s.45.04.68.12c.22.08.43.2.61.35.18.16.32.36.43.6.11.24.17.52.17.84v4.14c0,.33-.05.61-.17.85-.11.23-.25.43-.43.58-.18.16-.39.28-.61.36-.22.08-.45.12-.68.12s-.45-.04-.68-.12c-.22-.08-.42-.2-.6-.36-.18-.15-.33-.35-.44-.58s-.17-.52-.17-.85v-4.14ZM44.98,22.14c0,.27.08.47.23.6.15.13.33.19.53.19s.38-.06.53-.19c.15-.13.22-.33.22-.6v-4.14c0-.27-.08-.47-.22-.6-.15-.13-.33-.19-.53-.19s-.38.06-.53.19c-.15.13-.23.33-.23.6v4.14Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "white",
					d: "M48.58,23.99v-7.83h1.68c.31,0,.58.04.81.12.23.08.45.22.64.43.19.21.32.45.4.72s.11.65.11,1.12c0,.35-.02.65-.06.89s-.13.47-.26.68c-.15.26-.36.46-.62.6-.26.14-.59.21-1.01.21h-.57v3.06h-1.12ZM49.7,17.22v2.66h.54c.23,0,.4-.03.53-.1.12-.07.22-.16.28-.28.06-.11.09-.25.1-.41.01-.16.02-.34.02-.54,0-.18,0-.36-.01-.52,0-.17-.04-.31-.1-.43-.06-.12-.15-.22-.26-.29-.12-.07-.29-.1-.51-.1h-.58Z"
				})
			]
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Train",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "red",
					d: "M30.06,46.9c-2.69,1.99-5.23,2.8-8.77,2.8s-6.08-.81-8.77-2.8l-1.19,1.61c3.02,2.24,6,3.2,9.96,3.2s6.93-.96,9.96-3.2l-1.19-1.61Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M32.65,34.2c-.35-4.85-4.99-10.04-11.33-10.04s-10.98,5.19-11.33,10.04c-.28,3.87-.24,9.61,1.52,14.98,1.62,4.92,3.33,6.97,9.81,6.97s8.19-2.06,9.81-6.97c1.77-5.37,1.8-11.11,1.52-14.98ZM29.23,48.56c-1.36,4.15-2.33,5.6-7.91,5.6s-6.55-1.45-7.91-5.6c-1.66-5.06-1.7-10.53-1.43-14.22.29-3.95,4.11-8.19,9.34-8.19s9.05,4.23,9.34,8.19c.27,3.69.23,9.15-1.43,14.22Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M28.07,34.18c-.32-3.36-4.41-4.25-6.77-4.25s-6.45.9-6.77,4.25c-.28,2.91.82,4.79,1.8,5.87,1.29,1.42,3.15,2.27,4.98,2.27s3.69-.85,4.98-2.27c.97-1.07,2.08-2.96,1.8-5.87ZM24.79,38.7c-.9.99-2.24,1.61-3.5,1.61s-2.59-.62-3.5-1.61c-.7-.77-1.49-2.15-1.29-4.33.23-2.42,4.74-2.44,4.78-2.44s4.55.03,4.78,2.44c.21,2.18-.58,3.56-1.29,4.33Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M16.52,46.96c-.44,0-.84-.29-.96-.73l-.66-2.34c-.15-.53.16-1.08.69-1.23.53-.15,1.08.16,1.23.69l.66,2.34c.15.53-.16,1.08-.69,1.23-.09.03-.18.04-.27.04Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M26.08,46.96c-.09,0-.18-.01-.27-.04-.53-.15-.84-.7-.69-1.23l.66-2.34c.15-.53.71-.84,1.23-.69.53.15.84.7.69,1.23l-.66,2.34c-.12.44-.53.73-.96.73Z"
				})
			]
		})]
	})]
});
export default SvgAppIcBefehl32;
